import React from 'react';
import { Activity, Clock, TrendingUp, Zap } from 'lucide-react';
import FilterModalWrapper from './FilterModalWrapper';

/**
 * MarketModal - Desktop modal for selecting market type/game status
 * Handles filtering for live, pre-match, or all fixtures
 * Adapted from mobile MarketSheet
 *
 * @param {boolean} isOpen - Whether modal is open
 * @param {Function} onClose - Callback to close modal
 * @param {string} currentMarket - Currently selected market
 * @param {Function} onMarketChange - Callback when market is selected
 */
const MarketModal = ({
  isOpen,
  onClose,
  currentMarket,
  onMarketChange
}) => {
  const marketOptions = [
    { id: 'all', label: 'All Markets', icon: TrendingUp, description: 'Show all available fixtures' },
    { id: 'live', label: 'Live', icon: Zap, description: 'In-play fixtures only', color: 'red' },
    { id: 'prematch', label: 'Pre-match', icon: Clock, description: 'Upcoming fixtures only' }
  ];

  const handleMarketSelect = (marketId) => {
    onMarketChange(marketId);
  };

  return (
    <FilterModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title="Market Type"
      icon={Activity}
      maxWidth="sm"
      maxHeight="50vh"
    >
      {/* Market Options */}
      <div className="p-4">
        {marketOptions.map((option) => {
          const Icon = option.icon;
          const isSelected = currentMarket === option.id;
          const isLive = option.id === 'live' && option.color === 'red';

          return (
            <button
              key={option.id}
              onClick={() => handleMarketSelect(option.id)}
              className={`
                w-full flex items-center gap-3 p-3 rounded-lg transition-all mb-2
                ${isSelected
                  ? isLive
                    ? 'bg-red-500/20 border border-red-500/50'
                    : 'bg-emerald-500/20 border border-emerald-500/50'
                  : 'hover:bg-gray-800/50 border border-transparent'
                }
              `}
            >
              <div className={`
                p-2 rounded-lg
                ${isSelected
                  ? isLive ? 'bg-red-500/20' : 'bg-emerald-500/20'
                  : 'bg-gray-800'}
              `}>
                <Icon className={`
                  w-5 h-5
                  ${isSelected
                    ? isLive ? 'text-red-400' : 'text-emerald-400'
                    : 'text-gray-400'}
                `} />
              </div>

              <div className="flex-1 text-left">
                <div className={`
                  font-medium text-sm flex items-center gap-2
                  ${isSelected
                    ? isLive ? 'text-red-400' : 'text-emerald-400'
                    : 'text-white'}
                `}>
                  {option.label}
                  {isLive && isSelected && (
                    <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
                  )}
                </div>
                <div className="text-xs text-gray-500 mt-0.5">
                  {option.description}
                </div>
              </div>

              {isSelected && (
                <div className={`w-2 h-2 rounded-full ${isLive ? 'bg-red-400' : 'bg-emerald-400'}`} />
              )}
            </button>
          );
        })}
      </div>
    </FilterModalWrapper>
  );
};

export default MarketModal;
